import React from 'react'
import { Beaker } from '../Beaker'

export const ManualControlECButton = ({ handleClick, outEcA, outEcB, outEcC }) => {
    const bottlesStyle = {
        padding: 8,
    };

    return (
        <div
            className='canvas-bottles'
            onClick={handleClick}
            style={{
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                justifyContent: 'center',
            }}>
            <div
                style={bottlesStyle}
            >
                <Beaker
                    text='A'
                    title="Компонент A"
                    curState={
                        "11"
                        + String(Number(outEcA))
                    }
                    bottleHeight={68}
                    bottleWidth={32}
                />
            </div>
            <div
                style={bottlesStyle}
            >
                <Beaker
                    text='B'
                    title="Компонент B"
                    curState={
                        "11"
                        + String(Number(outEcB))
                    }
                    bottleHeight={68}
                    bottleWidth={32}
                />
            </div>
            <div
                style={bottlesStyle}
            >
                <Beaker
                    text='C'
                    title="Компонент C"
                    curState={
                        "11"
                        + String(Number(outEcC))
                    }
                    bottleHeight={68}
                    bottleWidth={32}
                />
            </div>

        </div>
    )
}
